import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import {
	Grid,
	GridCol,
	Header,
	HeaderBrand,
	HeaderNavigation,
	HeaderSubNavigation,
	HeaderUserWidget,
	HeaderWidgets,
	NavItem,
	Switch,
} from '@flixbus/honeycomb-react';

import FeedbackBanner from 'common/FeedbackBanner';
import { useFlixTheme } from 'contexts/ThemeContext';

import { CURRENTLY_DEPLOYED_BRANCH, DARK_MODE_LABEL } from './const';
import { getEnvClass } from './helpers';
import useAppHeader from './hooks/useAppHeader';
import { HEADER_TEXT } from './text';

import styles from './styles.module.css';

const AppHeader = observer(() => {
	const { isUserLoggedIn, userAccountName, visibleMenuItems, paths, handleAuthAction, branchName } =
		useAppHeader();
	const { toggleTheme, isDark } = useFlixTheme();
	const envClass = getEnvClass();

	const handleThemeToggle = () => {
		toggleTheme();
	};

	const headerClasses = classnames(styles.marginHeader, envClass);

	return (
		<>
			<FeedbackBanner />
			<Header
				extraClasses={headerClasses}
				fixed
				fullwidth
				widgetSize="l"
				navigation={
					<HeaderNavigation aria-label="Main navigation">
						{visibleMenuItems.map(({ uuid, link, prefix, title }) => (
							<NavItem key={uuid} href={link} active={paths[1] === prefix}>
								{title}
							</NavItem>
						))}
					</HeaderNavigation>
				}
				brand={
					<HeaderBrand
						href="/"
						src="https://honeycomb-assets.hive.flixbus.com/honeycomb-logos-static/2.0.0/svg/flix-white.svg"
						alt="Flix Dispatch"
						width="70"
						height="24"
						extraClasses={styles.brand}
					/>
				}
				widgets={
					<HeaderWidgets>
						<Grid align="center">
							<GridCol extraClasses={styles.themeSwitcher}>
								<Switch
									id="theme-switcher-header"
									extraClasses="theme-switcher"
									small
									label={DARK_MODE_LABEL}
									checked={isDark}
									onChange={handleThemeToggle}
								/>
							</GridCol>
							<GridCol extraClasses={styles.userWidget}>
								<HeaderUserWidget
									subMenu={
										<HeaderSubNavigation alignment="left" id="user-menu" aria-label="User menu">
											{isUserLoggedIn && (
												<NavItem href="/profile">{HEADER_TEXT.userProfile.profile}</NavItem>
											)}
											<NavItem Elem="button" onClick={handleAuthAction}>
												{isUserLoggedIn
													? HEADER_TEXT.userProfile.logoutButton
													: HEADER_TEXT.userProfile.loginButton}
											</NavItem>
											{branchName && (
												<NavItem>
													{CURRENTLY_DEPLOYED_BRANCH}
													<br />
													{branchName}
												</NavItem>
											)}
										</HeaderSubNavigation>
									}
								>
									{userAccountName}
								</HeaderUserWidget>
							</GridCol>
						</Grid>
					</HeaderWidgets>
				}
			/>
		</>
	);
});

export default AppHeader;
